import { Login } from "app/frame/Login/Login";
import { Navigation } from "app/frame/Navigation/Navigation";
import { Searchbar } from "app/frame/Searchbar/Searchbar";
import React, { ReactEventHandler } from "react";

import "./style.scss";
import { ServiceNavi } from "../ServiceNavi/ServiceNavi";
import { TopPartner } from "../TopPartner/TopPartner";

interface Props {
    desktop: boolean;
}

const Logo = ({ onStickyExpanderClick }: { onStickyExpanderClick: ReactEventHandler }) => (
    <div className="logoWrap">
        <div onClick={onStickyExpanderClick} className="stickyExpander" title="Navigation einblenden">
            <span>-</span>
        </div>
        <a
            href="https://www.t-online.de"
            data-ga-label="www.t-online.de"
            data-ga-action="click"
            data-ga-category="T-Logo"
        >
            <svg
                className="tlogo"
                width="590"
                height="120"
                viewBox="0 0 590 120"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g fill="#171B26">
                    <path d="m0 51.564v-15.151h12.826v-5.2511l16.27-21.693h7.9197v26.944h15.581v15.151h-15.581v38.393c0 4.9354 0.5165 8.1779 1.5495 9.7274 1.0904 1.5496 3.3285 2.3246 6.7145 2.3246 1.8938 0 4.0459-0.402 6.4562-1.206v17.303c-4.9928 1.033-9.8422 1.55-14.548 1.55-2.812 0-5.4806-0.201-8.0057-0.603-7.4032-1.205-12.195-4.706-14.376-10.502-0.8608-2.353-1.406-4.649-1.6356-6.887-0.2295-2.2379-0.3443-6.4273-0.3443-12.568v-37.532h-12.826z" />
                    <path d="m87.508 66.346v14.51h-32.329v-14.51h32.329z" />
                    <path d="m139.11 33.917c5.739 0 10.904 0.8321 15.495 2.4964 9.068 3.3285 15.84 9.1535 20.316 17.475 3.443 6.4275 5.165 14.29 5.165 23.587 0 13.257-4.075 23.845-12.224 31.765-7.403 7.173-17.016 10.76-28.838 10.76-12.568 0-22.611-4.017-30.129-12.052-7.403-7.862-11.104-18.221-11.104-31.076 0-12.568 3.5865-22.697 10.76-30.387 7.805-8.3787 17.991-12.568 30.559-12.568zm-1.033 16.958c-2.467 0-4.648 0.6026-6.542 1.8077-6.37 3.9599-9.555 12.023-9.555 24.189 0 3.9598 0.373 7.7475 1.119 11.363 0.976 4.5337 2.841 8.1492 5.595 10.846 2.755 2.6402 5.969 3.9602 9.642 3.9602 2.295 0 4.419-0.546 6.37-1.636 6.485-3.6155 9.727-11.679 9.727-24.189 0-3.845-0.344-7.4892-1.033-10.932-0.918-4.7059-2.783-8.4362-5.595-11.191-2.755-2.8121-5.997-4.2181-9.728-4.2181z" />
                    <path d="m191.1 117.5v-81.091h24.361v7.4892c5.682-6.6571 13.2-9.9856 22.554-9.9856 10.847 0 18.766 3.6155 23.759 10.846 3.099 4.4763 4.648 11.478 4.648 21.004v51.736h-24.189v-47.949c0-5.6241-0.631-9.5839-1.894-11.879-2.008-3.6155-5.308-5.4233-9.899-5.4233-5.969 0-10.302 2.8981-12.999 8.6944-1.435 2.9842-2.152 8.5223-2.152 16.614v39.943h-24.189z" />
                    <path d="m285.54 117.5v-117.5h24.189v117.5h-24.189z" />
                    <path d="m330.9 23.501v-23.501h25.653v23.501h-25.653zm0.688 94.003v-81.091h24.19v81.091h-24.19z" />
                    <path d="m375.84 117.5v-81.091h24.362v7.4892c5.681-6.6571 13.199-9.9856 22.554-9.9856 10.846 0 18.766 3.6155 23.759 10.846 3.099 4.4763 4.648 11.478 4.648 21.004v51.736h-24.189v-47.949c0-5.6241-0.632-9.5839-1.894-11.879-2.009-3.6155-5.309-5.4233-9.9-5.4233-5.968 0-10.301 2.8981-12.998 8.6944-1.435 2.9842-2.152 8.5223-2.152 16.614v39.943h-24.19z" />
                    <path d="m541.55 82.812h-53.888c0.689 13.946 5.768 20.918 15.237 20.918 5.796 0 9.9-2.869 12.31-8.608h24.275c-1.147 4.3041-3.271 8.321-6.37 12.052-7.001 8.551-16.958 12.826-29.871 12.826-12.338 0-22.18-3.702-29.526-11.105-7.748-7.862-11.621-18.364-11.621-31.506 0-12.166 3.529-22.296 10.588-30.387 7.575-8.7231 17.417-13.085 29.526-13.085 9.642 0 17.82 2.8981 24.534 8.6944 4.878 4.2468 8.494 9.5552 10.847 15.925 2.352 6.3128 3.672 14.405 3.959 24.275zm-25.566-14.462c-0.345-3.7303-1.062-6.8867-2.152-9.4692-2.468-5.8536-6.399-8.7805-11.794-8.7805-2.582 0-4.849 0.7461-6.8 2.2382-4.247 3.099-6.744 8.4361-7.49 16.012h28.236z" />
                </g>
                <rect x="559.83" y="88.121" width="29.383" height="29.383" fill="#E20074" />
            </svg>
        </a>
    </div>
);

let stickyTop: null | number = null;
let stickyHeight = 0;
const serviceHeight = 0;

const resizeFixedNavi = (desktop: boolean) => {
    const pageContainer: HTMLDivElement | null = document.querySelector("#Tall");
    const pageConatainerWidth = pageContainer ? pageContainer.offsetWidth : 1280;
    const pageHeader: HTMLDivElement | null = document.querySelector(".pageHeader");

    if (desktop && pageHeader) {
        pageHeader.style.width = `${pageConatainerWidth}px`;
    }
};

export const Header = ({ desktop }: Props) => {
    const stickyNodeRef = React.createRef() as React.RefObject<HTMLDivElement>;
    const [sticky, setSticky] = React.useState(false);
    const [collapsed, setCollapsed] = React.useState(false);

    React.useEffect(() => {
        const stickyNode = stickyNodeRef.current as HTMLElement;

        if (!stickyNode) {
            return;
        }

        const handleScroll = () => {
            resizeFixedNavi(desktop);
            const page = document.getElementById("page") as HTMLElement;
            if (stickyTop === null) {
                stickyTop = stickyNode.offsetTop;
                stickyHeight = stickyNode.offsetHeight;
                // serviceHeight = serviceNavi.offsetHeight;
            }

            if (desktop && (window.scrollY || window.pageYOffset) > stickyTop) {
                if (!sticky) {
                    setSticky(true);
                    document.body.classList.remove("not-scrolled");
                    stickyNode.style.top = `${-serviceHeight}px`;
                    page.style.paddingTop = `${stickyHeight + serviceHeight}px`;
                    if (!collapsed) {
                        setCollapsed(true);
                    }
                }
            } else if (sticky) {
                setSticky(false);
                document.body.classList.add("not-scrolled");
                page.style.paddingTop = "0";
                stickyNode.style.top = "0";
                setCollapsed(false);
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        // @ts-ignore
        return () => window.removeEventListener("scroll", handleScroll, { passive: true });
    }, [desktop, sticky, setSticky, collapsed, setCollapsed]);

    const classNames = ["pageHeader"];

    if (collapsed) {
        classNames.push("collapsed");
    }

    if (sticky) {
        classNames.push("sticky");
    }

    return (
        <header className={classNames.join(" ")}>
            <div ref={stickyNodeRef} className="wrapper">
                <div className="serviceContainer">
                    <ServiceNavi />
                    <TopPartner />
                </div>
                <Logo onStickyExpanderClick={() => setCollapsed(!collapsed)} />
                <Searchbar />
                <Login desktop={desktop} />
                <Navigation />
            </div>
        </header>
    );
};
